import { useContext, useState } from 'react'

import { Link, useHistory } from 'react-router-dom'
import { Button } from '../ui/button'

import { Col, Nav, Navbar } from 'react-bootstrap'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { AiOutlineLogout } from 'react-icons/ai'
import { FaRegUserCircle } from 'react-icons/fa'
import { HiOutlineEmojiHappy } from 'react-icons/hi'
import { MdSearch } from 'react-icons/md'
import { RiNotification3Line } from 'react-icons/ri'
import { MydnaLogoDark, MydnaLogoMobileDark } from '../../Icons/logo'
import SwitchCompany from '../Switcher/switch-company'
import DropdownMenu from './dropdown'

import { headerTextTranslate } from '../../i18n/translatedMessages.js'

import './mainMenu.sass'

import { CompanyContext } from '../../Store/CompanyContext'

const MainMenu = props => {
	const { store } = useContext(CompanyContext)

	const [value, setValue] = useState(store.language == 'ES' ? 'Español' : 'Português')
	const handleSelect = e => {
		setValue(e)
	}

	const { actions } = useContext(CompanyContext)
	const loggedEmail = localStorage.getItem('email')
	const allowSwitchCompanies = loggedEmail?.includes('miriam-cadena@mayekawa.com.mx') || loggedEmail?.includes('luciana.weber@artecola.com.br')

	const user_colab = JSON.parse(localStorage.getItem('user_both'))?.colab
	const allowHr = !!user_colab?.allowHr
	const history = useHistory()
	const switchView = () => {
		console.log('entrou')
		console.log('user_colab', user_colab)
		localStorage.setItem('user', JSON.stringify(user_colab))
		history.push('/employee')
	}

	return (
		<Navbar className='main-menu bg-md-light' sticky='top'>
			<Col className='main-menu-col' md={10} xs={12}>
				<Navbar.Brand href='/app'>
					<div className='desktop'>
						<MydnaLogoDark size={140} />
					</div>
					<div className='mobile'>
						<MydnaLogoMobileDark size={22} />
					</div>
				</Navbar.Brand>

				<Nav className='main-menu-mobile'>
					<Link to='/app'>
						<HiOutlineEmojiHappy />
					</Link>
					<Link to='/app'>
						<FaRegUserCircle />
					</Link>
					<Link to='/app'>
						<MdSearch />
					</Link>
					<Link to='/app'>
						<RiNotification3Line />
					</Link>
					<Link to='/app'>
						<AiOutlineLogout />
					</Link>
				</Nav>
				<Nav className='main-menu-nav d-flex align-items-center'>
					<a href={`https://ta.mydnadigital.com/login`} className='tw-rounded-full tw-bg-gray-500 py-2 px-3  hover:tw-bg-blue-400'>
						Talent Acquisition
					</a>

					{allowHr && (
						<div>
							<Button variant='white' className='rounded-pill tw-px-4 tw-w-52' onClick={switchView}>
								Ver como colaborador
							</Button>
						</div>
					)}
					<div>
						{!allowSwitchCompanies && <Link to='/app'>{headerTextTranslate.myBusiness}</Link>}
						{allowSwitchCompanies && <SwitchCompany email={loggedEmail} />}
						<Link to='/app/services/list'>{headerTextTranslate.myCollaborators}</Link>
					</div>
					<div className='bar-active-menu'></div>
				</Nav>
			</Col>

			<Col className='col-user-dropdown d-flex justify-content-end pe-5'>
				<DropdownButton
					className='dropdown-main-menu text-white'
					id='dropdown-basic-button'
					size='sm'
					variant='secondary'
					menuVariant='dark'
					title={<span style={{ color: 'white' }}>{value}</span>}
					onSelect={handleSelect}
				>
					<Dropdown.Item eventKey='Español' onClick={() => actions.setLanguage('ES')}>
						Español
					</Dropdown.Item>
					<Dropdown.Item eventKey='Português' onClick={() => actions.setLanguage('PT-BR')}>
						Português
					</Dropdown.Item>
				</DropdownButton>
			</Col>
			<Col md={-2} xs={0} className='col-user-dropdown d-flex justify-content-end pe-2'>
				<DropdownMenu />
			</Col>
		</Navbar>
	)
}
export default MainMenu
